import { ReactComponent as EditIcon } from 'core/assets/images/icones/editIcon.svg'
import { FormInput } from 'core/components/common/FormInput'
import { FormTextarea } from 'core/components/common/FormTextarea'
import { ApplicationIcon } from 'lauria/components/applications/ApplicationIcon'
import { ApplicationForm } from 'lauria/hooks/useEditApplication'
import React from 'react'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const ApplicationDescriptionCard: React.FC<{
  icone: string | null | undefined
  register: UseFormRegister<ApplicationForm>
  errors: FieldErrors<ApplicationForm>
  handleIntituleBlur: () => void
  handleIconClick: () => void
}> = ({ icone, register, errors, handleIntituleBlur, handleIconClick }) => {
  const { t } = useTranslation()
  return (
    <div>
      <div className="card app-description-card">
        <div className="flex flex-col items-center relative h-fit">
          <ApplicationIcon icone={icone} />
          <div className="edit-app-icon" onClick={handleIconClick}>
            <EditIcon className="text-blue-1350 h-[15px] w-[15px]" />
          </div>
        </div>
        <div className="flex flex-col ml-[10px] w-full">
          <FormInput
            fieldName="intitule"
            register={register}
            error={errors.intitule}
            wrapperClassName="md:w-[320px]"
            inputClassName="w-full form-input mb-[10px]"
            wrapperErrorClassName="h-[30px]"
            placeholder={t('applications.form.intitulePlaceholder')}
            onBlur={handleIntituleBlur}
          />
          <FormTextarea
            fieldName="description"
            register={register}
            error={errors.description}
            wrapperClassName="md:w-[320px]"
            inputClassName="w-full form-input h-[60px] resize-none"
            maxLength={100}
            showCounter
            placeholder={t('applications.form.descriptionPlaceholder')}
          />
        </div>
      </div>
    </div>
  )
}
